import { useCallback, useEffect } from 'react';
import useAlertNotify from 'src/components/Toasts/AlertNotifications/hooks/useAlertNotify';
import useAppEventEmitter from 'src/hooks/useAppEventEmitter';
import useGoToRoute from 'src/hooks/useGoToRoute';

export default function useEventEmitterAlertNotificationListener() {
	const appEventEmitter = useAppEventEmitter();
	const alertNotify = useAlertNotify();

	const goToRoute = useGoToRoute();

	const handleDownloadReady = useCallback(() => {
		alertNotify({
			id: 'download-ready-alert',
			alertType: 'minor',
			message: 'Download ready!',
			description: 'Your statement is ready for download.',
			action: {
				label: 'View now',
				callback: () => goToRoute('/portfolio/history?table=exports'),
			},
			disableAlertAutoDismiss: true,
		});
	}, [alertNotify, goToRoute]);

	useEffect(() => {
		appEventEmitter.on('downloadReady', handleDownloadReady);

		return () => {
			appEventEmitter.off('downloadReady', handleDownloadReady);
		};
	}, [appEventEmitter, handleDownloadReady]);
}
